import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { IProductSale, ProductSale } from '../../../../model/product-sale';
import { ISalesByProductApiService } from './sales-by-product-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportSalesByProductQueryDto } from './dtos/export-sales-by-product.query.dto';
import { FindSalesByProductQueryDto } from './dtos/find-sales-by-product.query.dto';
import { FindSalesByProductResponseDto } from './dtos/find-sales-by-product.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByProductMockApiService implements ISalesByProductApiService {
  data = {
    product_sales: {
      items: [] as ProductSale[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<IProductSale>,
      subject: new BehaviorSubject<Maybe<ProductSale[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get productSalesData() {
    return this.data['product_sales'] as Data<ProductSale, IProductSale>;
  }

  findSalesByProduct(query: FindSalesByProductQueryDto): Promise<FindSalesByProductResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportSalesByProduct(query: ExportSalesByProductQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
